<template>
  <el-row>
    <el-table v-if="reg && !meta.loading" :data="details" stripe  size="mini" border>
      <el-table-column label="评估时间" width="100" prop="execTime" align="center">
        <template slot-scope="{ row }">
          <span :title="$utils.fmtTime(row.execTime)">{{fmtTime(row.execTime)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="危重等级" width="80" prop="patientLevel" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.criticalLevel == Enum.CriticalLevel.濒危" type="danger" effect="dark" size="mini">{{ row.criticalLevel }}</el-tag>
          <el-tag v-else-if="row.criticalLevel == Enum.CriticalLevel.危重" type="danger" hit size="mini">{{ row.criticalLevel }}</el-tag>
          <el-tag v-else-if="row.criticalLevel == Enum.CriticalLevel.急症" type="warning" hit size="mini">{{ row.criticalLevel }}</el-tag>
          <el-tag v-else type="info" hit size="mini">{{ row.criticalLevel }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="意识状态" prop="consciousness" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.consciousness | dictText("Consciousness") }}
        </template>
      </el-table-column>
      <el-table-column label="既往病史" prop="pastHistory" width="150" align="center"> </el-table-column>
      <el-table-column label="六大病种" prop="sixMajorDiseases" width="150" align="center"> </el-table-column>
      <el-table-column label="复合伤" prop="ifCombinedInjury" width="80" align="center">
        <template slot-scope="{ row }">
          {{ row.ifCombinedInjury ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="收缩压" width="80" prop="vsBloodPressureSystolic" align="center"> </el-table-column>
      <el-table-column label="舒张压" width="80" prop="vsBloodPressureDiastolic" align="center"> </el-table-column>
      <el-table-column label="心率" width="80" prop="vsSphygmus" align="center"> </el-table-column>
      <el-table-column label="体温" width="80" prop="vsBodyTemperature" align="center"> </el-table-column>
      <el-table-column label="呼吸频率" width="80" prop="vsBreath" align="center"> </el-table-column>
      <el-table-column label="血氧" width="80" prop="vsSpo" align="center"> </el-table-column>
      <el-table-column label="血糖" width="80" prop="vsBloodSugar" align="center"> </el-table-column>
      <el-table-column label="血钾" width="80" prop="vsBloodPotassium" align="center"> </el-table-column>
      <el-table-column label="特殊群体" prop="specialGroup" width="70" align="center"> </el-table-column>
    </el-table>
    <el-skeleton v-if="meta.loading"/>
  </el-row>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "vuex";
  export default {
    props: {
      reg: Object,
      now: Date
    },
    data() {
      return {
        meta: {
          loading: false,
        },
        details: [],
      };
    },
    computed: {
      ...mapGetters(["dict", "dictEnum", "Enum", "permission", "user"]),
    },
    created() {
      this.getDetail();
    },
    methods: {
      getDetail() {
        this.meta.loading = true;
        api
          .queryAssess({
            mainId: this.reg.id,
            sort: "id",
            asc: false,
          })
          .then((res) => {
            this.details = res.items;
          })
          .catch((err) => {
            console.log(err);
            this.$message.error(err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      fmtTime(t) {
        let str = this.$utils.spanTime(t, this.now)
        let parts = str.split(":")
        if (Number(parts[0]) > 24) {
          return this.$utils.fmtTime(t)
        }
        if (Number(parts[0] > 0)) {
          return `${parts[0]} 小时以前`
        }
        if (Number(parts[1] > 0)) {
          return `${parts[1]} 分钟以前`
        }
        return `${parts[2]} 秒以前`
      }
    },
  };
</script>

